// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10775":"13efdab8","15993":"ea1b6412","17579":"13efdab8","30928":"7b36faad","72169":"13efdab8","78409":"ea1b6412","81149":"ea1b6412","95275":"13efdab8"}[chunkId] + ".chunk.css";
};